//#region ../src/state/subscribe-to-selector.ts
/**
* Subscribe to a specific derived value from the store, invoking `onChange`
* only when the selector result changes by strict reference equality (`!==`).
*
* This replaces the `let lastX = …; if (current !== lastX) { … }` pattern
* previously used in store-subscribers.ts.
*
* @param store    — subscribable store instance
* @param selector — pure function extracting a value from state
* @param onChange — callback receiving (current, previous) when the value changes
* @returns unsubscribe function
*/
function subscribeToSelector(store, selector, onChange) {
	let previous;
	return store.subscribe(() => {
		const current = selector(store.getState());
		if (current !== previous) {
			const prev = previous;
			previous = current;
			onChange(current, prev);
		}
	});
}
//#endregion
export { subscribeToSelector };
